module.exports = {"pathContext":{"name":"ImmunizationConnection","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"edges","type":{"kind":"LIST","name":null,"ofType":{"kind":"OBJECT","name":"ImmunizationEdge","ofType":null}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"pageInfo","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"OBJECT","name":"PageInfo","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/object-immunization-connection.json
// module id = 1807
// module chunks = 6283096841012